import _                                                                       from 'underscore';
import React, { FC, useContext }                                               from 'react';
import { formatOption, getProjectVersionsWhereIdAccessor, IFormatOptionValue } from '@src/util';
import { PreSelectedSelectField, Uuid }                                        from '@src/types';
import { useProjectTermDictionary }                                            from '@src/hooks';
import { SelectField }                                                         from '../../../components/forms';
import { useQuery }                                                            from "@apollo/react-hooks";
import { queriesHaveData, queriesLoading }                                     from "@src/store/_apolloUtil";
import { ProjectQueries }                                                      from "@src/queries/ProjectQueries";
import { ProjectContext }                                                      from "@src/views/pages/projects/ProjectIndexPage";
import { ProjectService }                                                      from "@src/services";


interface Props extends PreSelectedSelectField {
    projectId?: Uuid,
    projectVersionId?: Uuid,
}

const defaultProps: Props = {
    projectId:        null,
    projectVersionId: null,
}

const Dropdown: FC<Props> = ( props ) => {

    let projectContext                  = useContext( ProjectContext ),
        { projectId, projectVersionId } = projectContext || props,
        { getTerm }                     = useProjectTermDictionary();

    if( !projectId || !projectVersionId ) return null;

    const getProjectVersionMilestonesReq = useQuery(
        ProjectQueries.queries.GET_PROJECT( `
            ${ getProjectVersionsWhereIdAccessor( projectVersionId ) }{
                id
                projectVersionMilestones { 
                    id
                    name
                    milestoneDate
                }
            }
        ` ), {
            variables:   {
                id: projectId
            },
            fetchPolicy: 'cache-and-network'
        } );

    const isLoading = ( props.loading || queriesLoading( getProjectVersionMilestonesReq ) );

    let options = [] as IFormatOptionValue[];

    if( queriesHaveData( getProjectVersionMilestonesReq ) ){

        const project                  = _.first( getProjectVersionMilestonesReq.data.projects ),
              projectVersion           = ProjectService.getProjectVersionById( project?.projectVersions, projectVersionId ),
              projectVersionMilestones = projectVersion?.projectVersionMilestones;

        _.sortBy( projectVersionMilestones, 'milestoneDate' ).map( projectVersionMilestone => {

            const { id, name } = projectVersionMilestone;

            options.push(
                formatOption( id, name )
            );
        } )
    }

    return (
        <SelectField
            { ...props }
            loading={ isLoading }
            options={ options }>
        </SelectField>
    );
};

Dropdown.defaultProps = defaultProps;

export { Dropdown as ProjectVersionMilestonesDropdown };
